import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import AccountIcon from '@material-ui/icons/AccountBox';
import MarketingIcon from '@material-ui/icons/Description';
import MasterDataIcon from '@material-ui/icons/Storage';
import VoyageIcon from '@material-ui/icons/DirectionsBoat';
import BookingChangesIcon from '@material-ui/icons/ListAlt';
import WaiverIcon from '@material-ui/icons/NoteAdd';
import OverrideChargeIcon from '@material-ui/icons/FlipToFront';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import CROACCNTIcon from '@material-ui/icons/MonetizationOn';
// import SQUpdateIcon from '@material-ui/icons/LibraryBooks';
const styles = theme => ({
    menuItem: {
        '& $primary, & $icon': {
            color: theme.palette.primary.main,
        },
    },
    primary: {},
    icon: {},
});

function OutboundIcon() {
    return (
        <SvgIcon 
        // viewBox="0 0 64 64"
        >
            <path d="M14.08,15.59L16.67,13H7V11H16.67L14.08,8.41L15.5,7L20.5,12L15.5,17L14.08,15.59M19,3A2,2 0 0,1 21,5V9.67L19,7.67V5H5V19H19V16.33L21,14.33V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19Z" />
            {/* <path d="m58 36v22h-52v-52h22v-4h-26v60h60v-26z"/><path d="m44.808 30.192h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -8.64 41.527)"/><path d="m50.465 24.536h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -2.983 43.87)"/><path d="m53.293 21.707h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -.154 45.042)"/><path d="m47.636 27.364h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -5.809 42.708)"/><path d="m37.465 11.536h2v2h-2z" transform="matrix(.707 -.707 .707 .707 2.402 30.87)"/><path d="m31.808 17.192h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -3.255 28.527)"/><path d="m34.636 14.364h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -.427 29.698)"/><path d="m40.293 8.707h2v2h-2z" transform="matrix(.707 -.707 .707 .707 5.231 32.042)"/><path d="m19 33h2v-4h2v4h2v-4h2v4h2v-6h-10z"/><path d="m17 27h-6v26h26v-26h-6v8h-14zm14 24h-2v-2h2zm4 0h-2v-2h2zm-10-6h10v2h-10zm0 4h2v2h-2z"/><path d="m48.914 9.5-15.5 15.5h5.586v5.586l15.5-15.5 4.586 4.586c.209.208.498.328.793.328.618 0 1.121-.503 1.121-1.121v-15.879h-15.879c-.618 0-1.121.503-1.121 1.121 0 .3.116.581.328.793z"/> */}
        </SvgIcon>
    )
}
function InboundIcon() {
    return (
        <SvgIcon 
        // viewBox="0 0 64 64"
        >
            <path d="M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z" />
            {/* <path d="m58 36v22h-52v-52h22v-4h-26v60h60v-26z"/><path d="m45 5h2v4h2v-4h2v4h2v-6h-10v6h2z"/><path d="m17.5 40.914-4.586-4.586c-.209-.209-.498-.328-.793-.328-.618 0-1.121.503-1.121 1.121v15.879h15.879c.618 0 1.121-.503 1.121-1.121 0-.295-.119-.584-.328-.793l-4.586-4.586 15.5-15.5h-5.586v-5.586z"/><path d="m61 3h-6v8h-14v-8h-6v26h26zm-10 24h-2v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm0-4h-10v-2h10z"/><path d="m19.535 29.464h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -15.527 23.443)"/><path d="m16.707 32.293h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -18.355 22.272)"/><path d="m22.364 26.636h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -12.699 24.622)"/><path d="m25.192 23.808h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -9.87 25.787)"/><path d="m35.364 39.636h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -18.083 37.615)"/><path d="m38.192 36.808h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -15.255 38.787)"/><path d="m29.707 45.293h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -23.74 35.272)"/><path d="m32.535 42.465h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -20.912 36.444)"/> */}
        </SvgIcon>
    )
}

// function BookingChangesIcon() {
//     return (
//         <SvgIcon style={{ marginLeft: 2 }} viewBox="0 0 60 60">
//             <path d="M57.699,48.02c-0.549-0.105-1.069,0.24-1.18,0.781C55.403,54.303,51.074,58,45.749,58c-5.028,0-9.446-3.3-10.948-8H39.5v-2,h-8v8h2v-3.848C35.669,56.833,40.415,60,45.749,60c6.304,0,11.42-4.341,12.731-10.801C58.59,48.657,58.24,48.13,57.699,48.02z"/><path d="M57.5,36v4.308C55.25,35.855,50.796,33,45.749,33c-6.109,0-11.541,3.997-13.209,9.721c-0.154,0.53,0.15,1.085,0.681,1.239,c0.531,0.156,1.086-0.151,1.239-0.681C35.858,38.482,40.605,35,45.749,35c4.565,0,8.562,2.766,10.33,7H51.5v2h8v-8H57.5z"/><path d="M17.5,22h20V12h-20V22z M20.5,14h14v2h-14V14z M20.5,18h14v2h-14V18z"/><path d="M27.5,46.5C27.5,37.402,34.902,30,44,30c0.852,0,1.682,0.085,2.5,0.21V0h-35h-1h-9h-1v60h1h9h1h23.043,C30.291,57.012,27.5,52.08,27.5,46.5z M3.5,58V2h5v56H3.5z M15.5,10h24v14h-24V10z"/>
//         </SvgIcon>
//     )
// }
// function BookingChangesIcon() {
//     return (
//         <SvgIcon style={{ marginLeft: 2 }} height="682pt" viewBox="-51 -21 682 682.66669" width="682pt">
//         <path d="m351.183594 409.851562 1.554687-1.5625-47.402343-47.394531-1.519532 1.527344-12.445312 59.859375zm0 0"/><path d="m464.796875 200.632812-133.019531 133.6875 47.402344 47.402344 133.027343-133.679687zm0 0"/><path d="m369.824219 444.261719-124.058594 25.777343h-152.320313v-37.484374h157.519532l10.640625-51.230469h-168.15625v-37.488281h175.972656l50.976563-51.226563h-226.949219v-37.488281h264.25l92.652343-93.113282v-162.007812h-281.796874v170.464844h-170.222657v469.535156h452.019531v-276.660156zm0 0"/><path d="m131.066406 1.484375-131.492187 131.492187h131.492187zm0 0"/><path d="m521.546875 143.609375-30.308594 30.457031 47.40625 47.410156 30.28125-30.425781c13.09375-13.113281 13.09375-34.375.023438-47.441406-13.066407-13.070313-34.335938-13.070313-47.402344 0zm0 0"/>
//         </SvgIcon>
//     )
// }

// function WaiverIcon() {
//     return (
//         <SvgIcon viewBox="-32 0 448 448">
//             <path d="m24 0c-13.601562 0-24 10.398438-24 24v24h48v-24c0-13.601562-10.398438-24-24-24zm0 0"/><path d="m272 40h16v200h-16zm0 0"/><path d="m272 269.601562 8 12 8-12v-13.601562h-16zm0 0"/><path d="m336 400h-208v24c0 8.800781-3.199219 16.800781-8 24h240c13.601562 0 24-10.398438 24-24v-24zm0 0"/><path d="m320 24c0-13.601562-10.398438-24-24-24h-240c5.601562 7.199219 8 15.199219 8 24v400c0 13.601562 10.398438 24 24 24s24-10.398438 24-24v-40h208zm-160 192v-16h80v16zm80 72v16h-64v-16zm-32-104v-16h32v16zm-64-32v-16h96v16zm24-32v-16h72v16zm-40-32v-16h112v16zm-8-48h80v16h-80zm-40 32h32v16h-32zm0 32h72v16h-72zm0 32h48v16h-48zm0 32h112v16h-112zm0 32h64v16h-64zm80 128c0 13.601562-10.398438 24-24 24h-32c-13.601562 0-24-10.398438-24-24v-32c0-13.601562 10.398438-24 24-24h8v16h-8c-4.800781 0-8 3.199219-8 8v32c0 4.800781 3.199219 8 8 8h32c4.800781 0 8-3.199219 8-8v-8h16zm-13.601562-53.601562 11.203124 11.203124-40 40-11.203124-11.203124zm21.601562-26.398438h-88v-16h88zm120 96h-112v-16h112zm16-69.601562-16 24v13.601562h-16v-13.601562l-16-24v-234.398438c0-8.800781 7.199219-16 16-16h16c8.800781 0 16 7.199219 16 16zm0 0"/>
//         </SvgIcon>
//     )
// }

// function CROACCNTIcon() {
//     return (<SvgIcon height="512" viewBox="0 0 64 64" width="512">
//                 <path d="m28 22a6.006 6.006 0 0 0 5.91-5h-5.91a1 1 0 0 1 -1-1v-5.91a6 6 0 0 0 1 11.91z"/><path d="m29 10.09v4.91h4.91a6.008 6.008 0 0 0 -4.91-4.91z"/><path d="m44 12h-7a1 1 0 0 1 -1-1v-7h-24v42h30v-21a1 1 0 0 1 1-1h1zm-16-4a8 8 0 1 1 -8 8 8.009 8.009 0 0 1 8-8zm-12 36h-2v-2h2zm0-4h-2v-2h2zm0-4h-2v-2h2zm0-4h-2v-2h2zm0-4h-2v-2h2zm24 16h-22v-2h22zm0-4h-22v-2h22zm0-4h-22v-2h22zm0-4h-22v-2h22zm0-4h-22v-2h22z"/><path d="m55 45h2v2h-2z"/><path d="m8 18h2v28h-2z"/><path d="m31 52h2v4h-2z"/><path d="m42 48h-35a1 1 0 0 1 -1-1v-30a1 1 0 0 1 1-1h3v-2h-6v36h38z"/><path d="m23.414 58-2 2h21.172l-2-2z"/><path d="m55 38h2v2h-2z"/><path d="m38 5.414v4.586h4.586z"/><path d="m46 14v2h11a1 1 0 0 1 1 1v7h2v-10z"/><path d="m47 38h2v2h-2z"/><path d="m47 45h2v2h-2z"/><path d="m44 50h16v-24h-16zm15-2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1zm0-7a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1zm-14-13a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1-1zm0 9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1-1zm0 7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1-1z"/><path d="m46 18h10v6h-10z"/><path d="m47 29h10v4h-10z"/>
//             </SvgIcon>)}

function HUSTLINGIcon() {
    return (<SvgIcon viewBox="0 0 512 512">
           <path d="M449.48,142.68c-2.783-4.175-7.471-6.68-12.48-6.68h-45v90h20.728l-4.146-8.291c-3.706-7.412-0.703-16.421,6.709-20.127,c7.427-3.662,16.406-0.703,20.127,6.709L446.272,226h58.746L449.48,142.68z"/><path d="M287,46H15C6.709,46,0,52.709,0,61v225h302V61C302,52.709,295.291,46,287,46z M251.605,191.605l-30,30,c-5.859,5.859-15.352,5.859-21.211,0c-5.859-5.859-5.859-15.352,0-21.211l4.395-4.395H60c-8.291,0-15-6.709-15-15,c0-8.291,6.709-15,15-15h144.789l-4.395-4.395c-5.859-5.859-5.859-15.352,0-21.211c5.859-5.859,15.352-5.859,21.211,0l30,30,C256.626,175.415,257.926,185.283,251.605,191.605z"/><circle cx="105" cy="421" r="45"/><circle cx="407" cy="421" r="45"/><path d="M0,316v75c0,8.291,6.709,15,15,15h15h1.518c6.969-34.191,37.266-60,73.482-60s66.513,25.809,73.482,60H180h61h46,c8.291,0,15-6.709,15-15v-75H0z"/><path d="M377,256c-8.291,0-15-6.709-15-15V136h-15.234C338.61,136,332,142.61,332,150.766V406h1.518,c6.969-34.191,37.266-60,73.482-60c35.449,0,65.068,24.796,72.85,57.905C498.377,398.335,512,381.319,512,361V256H377z M437,316,h-30c-8.291,0-15-6.709-15-15c0-8.291,6.709-15,15-15h30c8.291,0,15,6.709,15,15C452,309.291,445.291,316,437,316z"/>
            </SvgIcon>)}

function CustomerRequestIcon() {
    return (<SvgIcon height="512" viewBox="0 0 192 192" width="512">
           <circle cx="48" cy="88" r="32"/><path d="m72 120h-8a8 8 0 0 0 -6.656 3.563l-9.344 14.015-9.344-14.015a8 8 0 0 0 -6.656-3.563h-8a24.027 24.027 0 0 0 -24 24v40a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-40a24.027 24.027 0 0 0 -24-24z"/><path d="m136 0c-30.878 0-56 21.533-56 48a43.667 43.667 0 0 0 12.255 30l-4.016 16.06a8 8 0 0 0 11.339 9.095l19.032-9.516a64.461 64.461 0 0 0 17.39 2.361c30.878 0 56-21.533 56-48s-25.122-48-56-48zm8 80h-16v-40h16zm-8-48a8 8 0 1 1 8-8 8 8 0 0 1 -8 8z"/>
	        </SvgIcon>)}

class ModuleList extends Component {
    state = {
        access: {}
    }

    componentDidMount() {
        if (this.props.roleDetailMenu) {
            let access = this.state.access;
            let masterdata = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'MASTERDATA'
            });
            let salesQuotation = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'SALESQUOTATION'
            });
            let systemAccount = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'SYSTEMACCOUNT'
            });
            let voyage = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'VOYAGE'
            });
            let outbound = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'OUTBOUND'
            });
            let inbound = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'INBOUND'
            });
            let bookingChanges = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'BOOKINGCHANGES'
            });

            let waiver = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'WAIVER'
            });

            let croAccounting = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'CROACCOUNTING'
            });

            let hustling = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'HUSTLING'
            });

            let customer = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'CUSTOMER'
            });

            // let sqUpdate = this.props.roleDetailMenu.find(roleDetailMenu => {
            //     return roleDetailMenu.menuId === 'SQUPDATE'
            // });

            let overrideCharge = this.props.roleDetailMenu.find(roleDetailMenu => {
                return roleDetailMenu.menuId === 'WAIVER'
            });

            access.masterdata = masterdata ? masterdata.isAllowed : false;
            access.salesQuotation = salesQuotation ? salesQuotation.isAllowed : false;
            access.systemAccount = systemAccount ? systemAccount.isAllowed : false;
            access.voyage = voyage ? voyage.isAllowed : false;
            access.outbound = outbound ? outbound.isAllowed : false;
            access.inbound = inbound ? inbound.isAllowed : false;
            access.bookingChanges = bookingChanges ? bookingChanges.isAllowed : false;
            access.waiver = waiver ? waiver.isAllowed : false;
            access.croAccounting = croAccounting ? croAccounting.isAllowed : false;
            access.hustling = hustling ? hustling.isAllowed : false;
            access.customer = customer ? customer.isAllowed : false;
            access.overrideCharge = overrideCharge ? overrideCharge.isAllowed : false;
            // access.sqUpdate = sqUpdate ? sqUpdate.isAllowed : false;
            this.setState({
                access
            })
        }
    }
    render() {
        const { history: { location: { pathname } }, classes } = this.props;
        const { access } = this.state;
        return (
            <div style={{ width: 250 }}>
                <List component="nav" dense disablePadding>
                    <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/' selected={'/' === pathname}>
                        <ListItemIcon className={classes.icon}>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.primary }} primary="Home" />
                    </ListItem>
                    {
                        access.systemAccount ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/system_account' selected={'/system_account' === pathname.substring(0, 15)}>
                                <ListItemIcon className={classes.icon}>
                                    <AccountIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="System Account" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.masterdata ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/master_data' selected={'/master_data' === pathname.substring(0, 12)}>
                                <ListItemIcon className={classes.icon}>
                                    <MasterDataIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Master Data" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.salesQuotation ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/sales_quotation' selected={'/sales_quotation' === pathname.substring(0, 16)}>
                                <ListItemIcon className={classes.icon}>
                                    <MarketingIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Sales Quotation" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.voyage ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/voyage' selected={'/voyage' === pathname.substring(0, 7)}>
                                <ListItemIcon className={classes.icon}>
                                    <VoyageIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Voyage" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.outbound ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/outbound' selected={'/outbound' === pathname.substring(0, 9)}>
                                <ListItemIcon className={classes.icon}>
                                    <OutboundIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Outbound" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.inbound ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/inbound' selected={'/inbound' === pathname.substring(0, 8)}>
                                <ListItemIcon className={classes.icon}>
                                    <InboundIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Inbound" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.bookingChanges ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/bookingChanges' selected={'/bookingChanges' === pathname.substring(0, 15)}>
                                <ListItemIcon className={classes.icon}>
                                    <BookingChangesIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Booking Changes" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.waiver ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/waiver' selected={'/waiver' === pathname.substring(0, 7)}>
                                <ListItemIcon className={classes.icon}>
                                    <WaiverIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Waiver" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.croAccounting ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/CROAccounting' selected={'/CROAccounting' === pathname.substring(0, 14)}>
                                <ListItemIcon className={classes.icon}>
                                    <CROACCNTIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="CRO Accounting" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.overrideCharge ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/overrideCharge' selected={'/overrideCharge' === pathname.substring(0, 15)}>
                                <ListItemIcon className={classes.icon}>
                                    <OverrideChargeIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Override" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.hustling ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/Hustling' selected={'/Hustling' === pathname.substring(0, 9)}>
                                <ListItemIcon className={classes.icon}>
                                    <HUSTLINGIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Hustling" />
                            </ListItem>
                        ) : ''
                    }
                    {
                        access.customer ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/customerRequest' selected={'/customerRequest' === pathname.substring(0, 16)}>
                                <ListItemIcon className={classes.icon}>
                                    <CustomerRequestIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="Customer Request" />
                            </ListItem>
                        ) : ''
                    }
                    {/* {
                        access.sqUpdate ? (
                            <ListItem className="userlink" classes={{ selected: classes.menuItem }} component={Link} to='/SQUpdate' selected={'/SQUpdate' === pathname.substring(0, 9)}>
                                <ListItemIcon className={classes.icon}>
                                    <SQUpdateIcon />
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.primary }} primary="SQ Update" />
                            </ListItem>
                        ) : ''
                    } */}
                </List>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { roleDetailMenu } = state.roleDetail;
    return {
        roleDetailMenu
    };
}
export default withRouter(connect(mapStateToProps)(withStyles(styles)(ModuleList)))
